@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.adverse-wrapper {
  width: 100%;
  padding: 2rem;
}

:global(.header-txt).adverse-header {
  text-align: center;
  margin: 32px 0;
  line-height: 33px;

  h2 {
    font-size: 1em;
    letter-spacing: -0.1px;
  }

  @media screen and (max-width: vars.$mobile) {
    font-size: 24px;
  }
}

.adverse-body a {
  color: colors.$link;

  &:hover {
    color: colors.$uplift-green;
    text-decoration: underline;
  }
}

.adverse-body {
  color: colors.$body-text;
}

// Flexpay

:global(.flexpay) {
  .adverse-header,
  .adverse-body {
    text-align: left;
  }
}
